import Trans from 'next-translate/Trans';

export const VatAndTransportInfo: FC = () => {
    return (
        <small className="ml-3 mb-[5px] text-small font-normal text-primary">
            <Trans
                i18nKey="incl. VAT., excl. <link>shipping costs</link>"
                components={{ link: <a href="/versand-zahlung" className="text-primary" target="_blank" /> }}
            />
        </small>
    );
};
